<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <div v-responsive.lg.xl>
      <div>
        <div style="background: #FFFBF6;height: auto">
          <div class="justify-content-center column pt-5 mt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('deja_assure.header') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
            <div class="row justify-content-center margin">
              <div class="justify-content-center row mt-5 mb-5 pb-5">
                <div class="d-flex justify-content-center align-items-center">
                  <div style="max-width: 55%;">                    
                    <!-- Nouveau formulaire basé sur la maquette -->
                    <div class="comparison-form-container">
                      <div class="form-header">
                        <h3>{{ $t('deja_assure.title') }}</h3>
                        <p>{{ $t('deja_assure.intro') }}</p>
                      </div>
                      
                      <div v-if="showFormStep1" class="form-content">
                        <div class="step-indicator">1/2</div>
                        <div class="form-group half-width">
                            <label class="form-label">{{ $t('deja_assure.type_contrat_label') }} *</label>
                            <select v-model="alreadyInsuredData.typeContrat" class="form-select">
                              <option value="Automobile">Automobile</option>
                              <option value="Habitation">Habitation</option>
                              <option value="Sante">Santé</option>
                              <option value="Multirisque Professionnelle">Multirisque Professionnelle</option>
                              <option value="Responsabilité Civile Professionnelle">Responsabilité Civile Professionnelle</option>
                            </select>
                          </div>

                        
                        
                        <div class="form-row">
                           <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.nombre_mois_label') }} *</label>
                          <select v-model="alreadyInsuredData.nbreMois" class="form-select">
  <option value="" disabled>Cliquez pour sélectionner</option>
  <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
</select>
                          <!-- <input 
                            @keypress="onlyNumber"
                            type="text" 
                            v-model="alreadyInsuredData.nbreMois" 
                            :placeholder="$t('deja_assure.nombre_mois_label')"
                            class="form-input"
                          > -->
                        </div> <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.prime_label') }} *</label>
                          <input 
                            v-money="money"
                            @keypress="onlyNumber"
                            type="text" 
                            v-model="alreadyInsuredData.primeActuelle" 
                            :placeholder="$t('deja_assure.prime_placeholder')"
                            class="form-input"
                          >
                        </div>
                        </div>
                       

                        
                        
                        <button class="etape-suivante-btn" @click="nextStep">
                           {{ $t('deja_assure.bouton_suivant_label') }}
                        </button>

                         
                      </div>

                       <div v-if="showFormStep2" class="form-content">
                        <div class="step-indicator">2/2</div> 
                        <div class="form-row">
                          <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.nom_label') }} *</label>
                          <select v-model="alreadyInsuredData.nomAssureur" class="form-select">
                            <option v-for="item in partenaireMetier" :value="item.value">{{ item.name }}</option>
                          </select>
                        </div>
                          
                          <div class="form-group half-width">
                            <label class="form-label">{{ $t('deja_assure.date_label') }} *</label>
                            <input 
                              type="date" 
                              v-model="alreadyInsuredData.endDate" 
                              class="form-input"
                            >
                          </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group half-width" v-if="alreadyInsuredData.nomAssureur == 'AUTRE'">
                          <label class="form-label">{{ $t('deja_assure.Autre_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.autreNomAssureur" 
                            placeholder=""
                            class="form-input"
                          >
                        </div>
                        </div>
                        <div class="form-row">
                           <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.first_name_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.firstname" 
                            :placeholder="$t('deja_assure.first_name_placeholder')"
                            class="form-input"
                          >
                        </div>

                         <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.last_name_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.lastname" 
                            :placeholder="$t('deja_assure.last_name_placeholder')"
                            class="form-input"
                          >
                        </div>
                        </div>

                        <div class="form-row">
                           <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.telephone_label') }} *</label>
                          <div class="phone-input-container">
                            <CountryCodeSelect 
                              :value="alreadyInsuredData.countryCode" 
                              @input="alreadyInsuredData.countryCode = $event"
                              search-placeholder="Sénégal"
                            />
                            <input 
                              @keypress="onlyNumber"
                              v-model="alreadyInsuredData.telephone" 
                              :placeholder="$t('deja_assure.telephone_placeholder')"
                              class="form-input phone-input"
                            >
                          </div>
                        </div>
                             <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.adresse_mail') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.email" 
                            :placeholder="$t('deja_assure.adresse_mail_placeholder')"
                            class="form-input"
                          >
                        </div>

                        </div>

                        <div class="form-row">
                          <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.is_from_broker_label') }}</label>
                          <v-switch v-model="alreadyInsuredData.isFromBroker" color="#ffa409" class="mt-0" :label="`${alreadyInsuredData.isFromBroker ? $t('deja_assure.oui_label') : $t('deja_assure.non_label')}`"></v-switch>
                        </div>
                        </div>
                        <!-- is_from_broker -->
                       
                        <div class="justify-content-between form-row" style="display: flex;margin-top: -30px;">
                            <button class="etape-retour-btn" @click="backStep">
                        {{ $t('deja_assure.bouton_retour_label') }}
                        </button>

                        <button class="validate-btn" @click="sending">
                          {{ $t('deja_assure.bouton_envoyer_label') }}
                        </button>
                        </div>
                      </div>

                      <div class="mt-5">
                          <span class="font-weight-bold">*</span> {{ $t('deja_assure.champs_obligatoire_label') }}
                        </div>
                    </div>
                  </div>
                  <div style="max-width: 40%;">
                    <img 
                      src="../../assets/img/already_insured.png" 
                      alt="numéro un" 
                      style="width: 100%; object-fit: contain;border-radius: 20px;"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <div style="margin-top: 10%;" v-responsive.sm.xs>
      <div>
        <div style="background: #FFFBF6;height:auto">
          <div class="justify-content-center column pt-5 pb-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop"
                  style="font-size: 20px;padding-left: 20px!important;padding-right: 20px!important;">{{ $t('deja_assure.header') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="justify-content-center column">
              <!-- Formulaire mobile -->
              <div class="mt-5 mobile-form-container">
                <div class="form-header-mobile">
                  <h3>{{ $t('deja_assure.title') }}</h3>
                  <p>{{ $t('deja_assure.intro') }}</p>
                </div>
                
                <div v-if="showFormStep1" class="form-content-mobile">
                  <div class="step-indicator-mobile">1/2</div>
                  <div class="form-group-mobile">
                    <label class="form-label-mobile">{{ $t('deja_assure.type_contrat_label') }} *</label>
                    <select v-model="alreadyInsuredData.typeContrat" class="form-select-mobile">
                        <option value="Automobile">Automobile</option>
                        <option value="Habitation">Habitation</option>
                        <option value="Sante">Santé</option>
                        <option value="Multirisque Professionnelle">Multirisque Professionnelle</option>
                        <option value="Responsabilité Civile Professionnelle">Responsabilité Civile Professionnelle</option>
                    </select>
                  </div>
                
                   <div class="form-group-mobile">
                    <label class="form-label-mobile">{{ $t('deja_assure.nombre_mois_label') }} *</label>
                    <select v-model="alreadyInsuredData.nbreMois" class="form-select">
  <option value="" disabled>Cliquez pour sélectionner</option>
  <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
</select>
                    <!-- <input 
                      @keypress="onlyNumber" 
                      v-model="alreadyInsuredData.nbreMois" 
                      :placeholder="$t('deja_assure.nombre_mois_label')"
                      class="form-input-mobile"
                    > -->
                  </div>
                  
                  <div class="form-group-mobile">
                    <label class="form-label-mobile">{{ $t('deja_assure.prime_label') }} *</label>
                    <input 
                      v-money="money"
                      @keypress="onlyNumber" 
                      v-model="alreadyInsuredData.primeActuelle" 
                      :placeholder="$t('deja_assure.prime_placeholder')"
                      class="form-input-mobile"
                    >
                  </div>
                  
                  <button class="etape-suivante-btn-mobile" @click="nextStep">
                    {{ $t('deja_assure.bouton_suivant_label') }}
                  </button>
                </div>

                 <div v-if="showFormStep2" class="form-content">
                        <div class="step-indicator">2/2</div> 
                          <div class="form-group-mobile">
                    <label class="form-label-mobile">{{ $t('deja_assure.nom_label') }} *</label>
                    <select v-model="alreadyInsuredData.nomAssureur" class="form-select-mobile">
                     <option v-for="item in partenaireMetier" :value="item.value">{{ item.name }}</option>
                    </select>
                  </div>

                  <div class="form-group-mobile" v-if="alreadyInsuredData.nomAssureur == 'AUTRE'">
                          <label class="form-label-mobile">{{ $t('deja_assure.Autre_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.autreNomAssureur" 
                            placeholder=""
                            class="form-input"
                          >
                        </div>
                  
                  <div class="form-group-mobile">
                    <label class="form-label-mobile">{{ $t('deja_assure.date_label') }} *</label>
                    <input 
                      type="date" 
                      v-model="alreadyInsuredData.endDate" 
                      class="form-input-mobile"
                    >
                  </div>
                        <div class="form-row">

                           <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.first_name_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.firstname" 
                            :placeholder="$t('deja_assure.first_name_placeholder')"
                            class="form-input"
                          >
                          </div>
                          </div>
                           <div class="form-row">
                         <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.last_name_label') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.lastname" 
                            :placeholder="$t('deja_assure.last_name_placeholder')"
                            class="form-input"
                          >
                        </div>
                        </div>
                        



                        <div class="form-row">
                           <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.telephone_label') }} *</label>
                          <div class="phone-input-container-mobile">
                            <CountryCodeSelect 
                              :value="alreadyInsuredData.countryCode" 
                              @input="alreadyInsuredData.countryCode = $event"
                              search-placeholder="Sénégal"
                            />
                            <input 
                              @keypress="onlyNumber"
                              v-model="alreadyInsuredData.telephone" 
                              :placeholder="$t('deja_assure.telephone_placeholder')"
                              class="form-input-mobile phone-input-mobile"
                            >
                          </div>
                        </div>
                        </div>

                        <div class="form-row">
                             <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.adresse_mail') }} *</label>
                          <input 
                            type="text" 
                            v-model="alreadyInsuredData.email" 
                            :placeholder="$t('deja_assure.adresse_mail_placeholder')"
                            class="form-input"
                          >
                        </div>
                        </div>

                        <div class="form-row">
                          <div class="form-group half-width">
                          <label class="form-label">{{ $t('deja_assure.is_from_broker_label') }}</label>
                          <v-switch v-model="alreadyInsuredData.isFromBroker" color="#ffa409" class="mt-0" :label="`${alreadyInsuredData.isFromBroker ? $t('deja_assure.oui_label') : $t('deja_assure.non_label')}`"></v-switch>
                        </div>
                        </div>
                        
                        
                       
                        <div class="justify-content-between form-row" style="display: flex;margin-top: -30px;">
                            <button class="etape-retour-btn" @click="backStep">
                        {{ $t('deja_assure.bouton_retour_label') }}
                        </button>

                        <button class="validate-btn" @click="sending">
                          {{ $t('deja_assure.bouton_envoyer_label') }}
                        </button>
                        </div>
                      </div>

                       <div class="mt-5">
                          <span class="font-weight-bold">*</span> {{ $t('deja_assure.champs_obligatoire_label') }}
                        </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('deja_assure.envoie_en_cours_label') }}</span>
      </div>
  </v-container>
</template>

<script>
import Api from '../../services/Api';
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import PartenaireMetier from '../../common/PartenaireMetier.json';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IntlNumber from '../../common/intlNumber.json';
import CountryCodeSelect from '../../views/CountryCodeDejaAssure.vue';

const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour l'indicatif ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour l'indicatif ${countryCode}` };
    }
};

const validateEmail = email => {
    if (!email.length) {
        return { valid: false, error: "L'adresse mail est obligatoire!" };
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
        return { valid: false, error: "Veuillez entrer un email valide!" };
    } else {
        return { valid: true, error: null };
    }
};

export default {
  name: 'partenaire_section',
  components: {
    simplebar,
    CountryCodeSelect
  },
  data: () => ({
    partenaireMetier: PartenaireMetier,
    intlNumber: IntlNumber,
    dialogLoading : false,
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    showFormStep1: true,
    showFormStep2: false,
    step : 1,
    alreadyInsuredData: {
      autreNomAssureur: null,
      nomAssureur: null,
      typeContrat: null,
      endDate: null,
      nbreMois : null,
      primeActuelle: null,
      firstname : null,
      lastname : null,
      fullName: null,
      telephone: null,
      email: null,
      isFromBroker : null,
      countryCode: '+221'
    }, 
    money: {
          thousands: ' ',
          precision: false,
          masked: false,
        },
    ToastTabSucess: { // Customized options for success toast
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'success',
      className: 'custom-success-class'
    },
    ToastTabError: { // Customized options for error toast
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'error'
    },
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
      onlyNumber($event) {
        let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },

    startComparison() {
      this.showFormStep1 = !this.showFormStep1;
    },
    
    nextStep() {
      if (!this.alreadyInsuredData.typeContrat || !this.alreadyInsuredData.primeActuelle || !this.alreadyInsuredData.nbreMois) {
          this.$toasted.show("Les champs * sont obligatoire", this.ToastTabError);
          return;
      }

      this.showFormStep2 = true;
      this.showFormStep1 = false;

    },
    backStep(){
      this.showFormStep2 = false;
      this.showFormStep1 = true;
    },

    clearForm () {
        this.alreadyInsuredData.nomAssureur = null
        this.alreadyInsuredData.typeContrat = null
        this.alreadyInsuredData.nbreMois = null
        this.alreadyInsuredData.endDate = null
        this.alreadyInsuredData.primeActuelle = null
        this.alreadyInsuredData.firstname = null
        this.alreadyInsuredData.lastname = null
        this.alreadyInsuredData.telephone = null
        this.alreadyInsuredData.email = null
    },

   async sendingControl() {
        let errors = {}
        const validPhone = validatePhoneWithIndicatif(this.alreadyInsuredData.telephone, this.alreadyInsuredData.countryCode);
        errors.phone = validPhone.error;

        if(validPhone.valid == true) {
         this.sending()
        } else {
          this.$toasted.show(validPhone.error, this.ToastTabError);
          return
        }  
    }, 

    
    sending() {
      if (!this.alreadyInsuredData.firstname || !this.alreadyInsuredData.lastname || !this.alreadyInsuredData.telephone || !this.alreadyInsuredData.nomAssureur || !this.alreadyInsuredData.endDate || !this.alreadyInsuredData.email) {
        this.$toasted.show("Les champs * sont obligatoire", this.ToastTabError);
        return;
      }

      if (this.alreadyInsuredData.nomAssureur === 'AUTRE' && !this.alreadyInsuredData.autreNomAssureur) {
        this.$toasted.show("Le champ Autre assureur est obligatoire", this.ToastTabError);
        return;
      } else {
        this.alreadyInsuredData.autreNomAssureur = '';
      }

      // Check if selected date is not in the past
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time part for date comparison
      const selectedDate = new Date(this.alreadyInsuredData.endDate);
      
      if (selectedDate < today) {
          this.$toasted.show("La date de fin ne peut pas être dans le passé", this.ToastTabError);
          return;
      }

      let errors = {}
      const validEmail = validateEmail(this.alreadyInsuredData.email);
      errors.email = validEmail.error;

      if (validEmail.valid != true) { 
          this.$toasted.show(validEmail.error, this.ToastTabError);
          return
      } 

      const validPhone = validatePhoneWithIndicatif(this.alreadyInsuredData.telephone, this.alreadyInsuredData.countryCode);
      errors.phone = validPhone.error;

      if(validPhone.valid != true) {
        this.$toasted.show(validPhone.error, this.ToastTabError);
        return
      }  
 
        // sending data to Api for getting Response 
        const isFromBroker = this.alreadyInsuredData.isFromBroker ? 'OUI' : 'NON';
         let numberClient = (this.alreadyInsuredData.countryCode + this.alreadyInsuredData.telephone).substring(1)
         
        let alreadyInsuredData = {
            nomAssureur: this.alreadyInsuredData.nomAssureur,
            autreNomAssureur: this.alreadyInsuredData.autreNomAssureur,
            typeContrat: this.alreadyInsuredData.typeContrat,
            endDate: this.alreadyInsuredData.endDate,
            nbreMois : this.alreadyInsuredData.nbreMois,
            primeActuelle: this.alreadyInsuredData.primeActuelle,
            firstname: this.alreadyInsuredData.firstname,
            lastname: this.alreadyInsuredData.lastname,
            telephone: numberClient,
            email: this.alreadyInsuredData.email,
            is_from_broker: isFromBroker,
            plateforme: "Front",
        }
        this.dialogLoading = true

        Api().post('message/dejaassure', alreadyInsuredData)
        .then(response => {
            setTimeout(() => {
                this.dialogLoading = false
                this.clearForm()
                 this.$toasted.show("Merci, les données ont été envoyé avec succès", this.ToastTabSucess);
                 this.showFormStep2 = false;
                 this.showFormStep1 = true;
            }, 3000);
        }).catch(error => {
             setTimeout(() => {
                this.dialogLoading = false
                this.$toasted.show("Une erreur est survenue, veuillez réessayer", this.ToastTabError);
            }, 3000);
            console.log('erreur', error)
        })
    },
  },

  mounted() {
    window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
  }
.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}


a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  //text-transform: uppercase;
}

h3 {
  font-size: 20px;
  //text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

.text-lg-left {
  text-align: left !important;
}

.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}

/* Styles pour le nouveau formulaire de comparaison */
.comparison-form-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  max-width: 500px;
}

.form-header {
  //text-align: center;
  margin-bottom: 20px;
}

.form-header h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 500;
}

.cest-parti-btn {
  background: #ffa409;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cest-parti-btn:hover {
  background: #e8930a;
}

.form-content {
  position: relative;
}

.step-indicator {
  position: absolute;
  top: -10px;
  right: 0;
  background: #f5f5f5;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.form-group {
  margin-bottom: 16px;
}

.form-row {
  display: flex;
  gap: 12px;
}

.half-width {
  flex: 1;
}

.form-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-select,
.form-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  transition: border-color 0.3s ease;
}

.form-select:focus,
.form-input:focus {
  outline: none;
  border-color: #ffa409;
}

.form-select {
  cursor: pointer;
}

.validate-btn {
  width: 48%;
  background: #ffa409;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.validate-btn:hover {
  background: #ed9a0a;
}

.etape-retour-btn {
  width: 48%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.etape-retour-btn:hover {
  background: #e8e8e8;
}

.etape-suivante-btn {
  width: 100%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.etape-suivante-btn:hover {
  background: #e8e8e8;
}

/* Styles mobile */
.mobile-form-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-header-mobile {
  text-align: center;
  margin-bottom: 20px;
}

.form-header-mobile h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 500;
}

.cest-parti-btn-mobile {
  background: #ffa409;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.form-content-mobile {
  position: relative;
}

.step-indicator-mobile {
  position: absolute;
  top: -10px;
  right: 0;
  background: #f5f5f5;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.form-group-mobile {
  margin-bottom: 16px;
}

.form-label-mobile {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-select-mobile,
.form-input-mobile {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
}

.etape-suivante-btn-mobile {
  width: 100%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
}


  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.lightning-box {
    position: absolute;
    top: 10px;
    width: 30px;
    left: 5px!important;
}
/* Styles pour le conteneur du téléphone avec indicatif */
.phone-input-container {
  display: flex;
  align-items: center;
  gap: 0px;
}

.phone-input-container-mobile {
  display: flex;
  align-items: center;
  gap: 0px;
  // margin-bottom: 20px;
}

.country-code-select {
  max-width: 100px;
  //padding: 12px;
  //border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 12px;
  background-color: white;
  cursor: pointer;
}

.country-code-select-mobile {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
  margin-bottom: 8px;
}

.phone-input {
  flex: 1;
  border-radius: 8px !important;
  margin-left: 5px;
  // border-left: none !important;
}

.phone-input-mobile {
  width: 100%;
  border-radius: 8px!important;
  margin-left: 5px;
  // border-left: none !important;
}

.country-code-select:focus,
.country-code-select-mobile:focus {
  outline: none;
  border-color: #ffa409;
  box-shadow: 0 0 0 2px rgba(255, 164, 9, 0.2);
}

.form-select {
  cursor: pointer;
}

.validate-btn {
  width: 48%;
  background: #ffa409;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.validate-btn:hover {
  background: #ed9a0a;
}

.etape-retour-btn {
  width: 48%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.etape-retour-btn:hover {
  background: #e8e8e8;
}

.etape-suivante-btn {
  width: 100%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
  transition: background-color 0.3s ease;
}

.etape-suivante-btn:hover {
  background: #e8e8e8;
}

/* Styles mobile */
.mobile-form-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-header-mobile {
  text-align: center;
  margin-bottom: 20px;
}

.form-header-mobile h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 500;
}

.cest-parti-btn-mobile {
  background: #ffa409;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.form-content-mobile {
  position: relative;
}

.step-indicator-mobile {
  position: absolute;
  top: -10px;
  right: 0;
  background: #f5f5f5;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.form-group-mobile {
  margin-bottom: 16px;
}

.form-label-mobile {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.form-select-mobile,
.form-input-mobile {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
}

.etape-suivante-btn-mobile {
  width: 100%;
  background: #f5f5f5;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 16px;
}


  // css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}

.lightning-box {
    position: absolute;
    top: 10px;
    width: 30px;
    left: 5px!important;
}
</style>

